import ZBlockquote from './ZBlockquote.vue'

export default ZBlockquote